module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-Bold-ac9dfb913b2846d4ca7015a4112fb99d.woff2";